import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ContactInfoModel extends BaseModel {
  @attr("string") relatedProvider;
  @attr("string") contactLabel;
  @attr("string") contentType;
  @attr("string") objectId;
  @attr("string") display;
}
